import { debounce, ON_CHANGE_DEBOUNCE_TIMER, } from '@/scripts/core/global'
import { TsDOM as q } from '@/scripts/core/TsDOM'
import { UcoastEl } from '@/scripts/core/UcoastEl'
import { type CartDrawer } from '@/scripts/cart/cart-drawer'
import {type Cart, DiscountAllocation} from '@/scripts/types/api'

type MessageType = 'success' | 'error' | 'has_better';

export class CartDiscount extends UcoastEl {
	static htmlSelector = 'cart-discount'
  static selectors = {
    applyButtonSpinner: '[data-uc-discount-apply-button-spinner]',
  };
	input: HTMLTextAreaElement
	cart: CartDrawer
	form: HTMLFormElement
  button: HTMLButtonElement // include a dedicated button listener to ensure the type="submit" doesnt trigger other forms
	constructor() {
		super()
		this.input = q.rs('input', this)
		this.cart = q.rs<CartDrawer>('cart-drawer')

		this.form = q.rs('form', this)
    this.button = q.rs('button', this)
		this.input.addEventListener('change', debounce(this.resetForm.bind(this), ON_CHANGE_DEBOUNCE_TIMER))
		this.form.addEventListener('submit', this.attemptApplyDiscount.bind(this))
    this.button.addEventListener('click', this.attemptApplyDiscount.bind(this))
	}

  getMessageEl(container: HTMLElement = this): HTMLElement {
    return q.rs('[data-uc-cart-discount-message]', container);
  }

	resetForm() {
    this.hideMessage();
	}
  setSpinnerVisibility(isVisible: boolean) {
    const spinners = q.ol(CartDiscount.selectors.applyButtonSpinner, this);
    spinners?.forEach((spinner) => {
      if (isVisible) {
        spinner.classList.add('active');
      } else {
        spinner.classList.remove('active');
      }
    });
  }
  getDefaultMessage(messageType: MessageType) {
    return this.getCodeSpecificMessage('default', messageType);
  }
  getCodeSpecificMessage(code: string, messageType: MessageType) {
    if (messageType === 'success') {
      return q.rs(`[data-uc-cart-discount-message-success-${code.toLowerCase()}]`, this).innerHTML;
    }
    if (messageType === 'has_better') {
      return q.rs(`[data-uc-cart-discount-message-has-better-${code.toLowerCase()}]`, this).innerHTML;
    }
    return q.rs(`[data-uc-cart-discount-message-error-${code.toLowerCase()}]`, this).innerHTML;
  }
  setMessage(messageType: 'success' | 'error' | 'has_better', code: string, messageEl = this.getMessageEl()) {
    // check if there's a code-specific message
    try {
      messageEl.innerText = this.getCodeSpecificMessage(code, messageType);
    } catch (err) {
      messageEl.innerHTML = this.getDefaultMessage(messageType);
    }
    messageEl.classList.add('active');
  }
  hideMessage() {
    this.getMessageEl().classList.remove('active');
  }
	async attemptApplyDiscount(event: Event) {
		event.preventDefault()
    this.setSpinnerVisibility(true);
    this.hideMessage();

		const discountCode = this.input.value
		document.cookie = `discount_code=${discountCode}; path=/`
		// Send GET request to "/discount/[discountcode]"
		const newCart: Cart | undefined = await fetch(`/discount/${discountCode}`)
			.then(async () => {
        // After the discount code has been applied, force the cart to update so the discount is visible instantly
        const response = await fetch(`${window.routes.cart_update_url}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            updates: {},
            sections: ['cart-drawer']
          }),
        })
        /*const text = await response.text()
        console.log({response: text})
        return JSON.parse(text)*/
			})
			.catch(function (error) {
				console.error('Error:', error)
			});
		/*console.log('newCart', { newCart });
		if (!newCart) {
			return
		}
		let hasDiscount = false
    hasDiscount = includeDiscount(newCart.cart_level_discount_applications, discountCode);
		for (let i = 0; i < newCart.items.length; i++) {
			const item = newCart.items[i]
      hasDiscount = hasDiscount || includeDiscount(item.line_level_discount_allocations, discountCode);
		}*/

    try {
      this.setMessage('success', discountCode, this.getMessageEl(this.cart));
    } catch(e) {
      this.setMessage('error', discountCode);
    } finally {
      this.setSpinnerVisibility(false);
    }
	}
}

function includeDiscount(discounts: DiscountAllocation[], discountCode: string): boolean {
  return discounts.some((discount) => discount.discount_application.title === discountCode.toUpperCase());
}
